import { useEffect, useState, useContext } from "react";
import { getWallet } from "../Utils/utils";
import { WalletContext } from "../contexts/Wallet-context";
import {  getTelegramUserTasksByWalletId } from "../services/HTTPService";

const WalletPage = () => {
    const [wallet, setWallet] = useState({});
    let [amount, setAmount] = useState(wallet.amount || 0);
    let stWallet = useContext(WalletContext);
    const w = localStorage.getItem('userWallet');
    const walletId = w ? JSON.parse(w).address : null;
    const [generalTasksData, setGeneralTasksData] = useState([]);
    const [totalReward, setTotalReward] = useState(0);

    const getUserTasks = () => {
        if(walletId) {
            getTelegramUserTasksByWalletId(walletId).then((res) => {
                if(res) {
                    console.log(res);
                    setGeneralTasksData(res);
                }
            })
        }
    }

    const calculateRewards = (tasks) => {
        let reward = 0;
        tasks.forEach(task => {
            if(task.isVisited) {
                reward += task.rewardAmount ? parseInt(task.rewardAmount) : 0;
            }
        });
        setTotalReward(reward);
        console.log("Total Reward:", reward);
        return reward;
    }

    useEffect(() => {
        if(generalTasksData && generalTasksData.length > 0) {
            calculateRewards(generalTasksData);
        }
    }, [stWallet, amount, generalTasksData])

    useEffect(() => {
        // 0xa3434719e10ecbfdb4ba31332775fa0b32a8a3bc
        const w = getWallet();
        setWallet(w);
        setAmount(w.amount || 0);
        amount = w.amount;
        console.log(w);   
        getUserTasks(); 
    }, [stWallet, amount])

    return (
        <div className="wallet-page">
            <ul className="padding-0">
                <li className="flex-box wallet-li">
                    <h3>Wallet</h3>
                    <span className="wallet-b">Balance <span>{Math.round(amount)} $SGT</span></span>
                </li>
                <li className="flex-box wallet-li">
                    <span className="wallet-b">Points<span>{totalReward} $SGT Points</span></span>
                </li>
            </ul>
        </div>
    );
}   

export default WalletPage;